import Svg from '@doordash/component-svg'
import * as React from 'react'
import styled from 'styled-components'
import { ImgProps } from '../'

const Text = styled.text`
  font: normal 14px DD-TTNorms;
  font-weight: 500;
  fill: #191919;
`

type RedCardProps = {
  withText?: boolean
  lastfour?: string
  delightnumber?: string
}

// tslint:disable:max-line-length
export const RedCard: React.SFC<ImgProps & RedCardProps> = ({
  height,
  withText,
  lastfour,
  delightnumber,
}) => (
  <Svg
    height={height}
    width={withText ? 324 : 200}
    fill="none"
    viewBox={`0 0 ${withText ? 324 : 200} ${height}`}
  >
    <rect width="190" height="119" rx="12" fill="#FF3008" />
    <path
      d="M18.3 50.6s-.4 1-1.8 1.1V53H18V59h1.8v-8.4h-1.5zM29.4 59v-1.7h-3.6c1-1.5 3.6-1.9 3.6-4.2 0-1.5-1.2-2.7-3-2.7-2.3 0-2.9 2-2.9 2l1.5.7s.3-1 1.4-1c.7 0 1.2.4 1.2 1 0 2-4 2-4 5.9h5.8zm7.9-4.4s1.2-.5 1.2-1.8-1.1-2.4-2.8-2.4c-2 0-3 1.3-3 1.3l1.2 1s.6-.7 1.6-.7c.7 0 1.1.4 1.1 1 0 .5-.4 1-1.1 1h-.9v1.5h1c.8 0 1.3.4 1.3 1s-.5 1.1-1.4 1.1c-1.2 0-2-.9-2-.9l-1 1.2s1 1.3 3.2 1.3c2 0 3-1.2 3-2.5 0-1.7-1.4-2.1-1.4-2.1zm10.4 1.3v-5.3h-2.1l-3.7 5.1v1.8h4V59h1.8v-1.5h1v-1.6h-1zm-1.8 0h-2.3l2.3-3.2v3.2zm14-2.5c-.8 0-1.2.3-1.2.3v-1.5h3.6v-1.6h-5.1l-.3 4.8 1.2.1s.4-.6 1.4-.6c.8 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4-1.2 0-2-.9-2-.9l-1 1.2s1 1.3 3.1 1.3c2 0 3.2-1.3 3.2-3 0-1.6-1.2-2.8-2.8-2.8zm9.7-.1h-.4l1.8-2.7h-1.8l-2.4 3.6s-.7.9-.7 2c0 1.7 1.3 3 3.2 3 1.8 0 3.2-1.3 3.2-3a3 3 0 0 0-3-2.9zm1.1 3c0 .7-.6 1.3-1.4 1.3-.9 0-1.5-.6-1.5-1.4 0-.7.6-1.3 1.5-1.3.8 0 1.4.6 1.4 1.3zm4.5-5.7v1.6H79L75.8 59h1.8l3.3-7v-1.4h-5.7zm12 7c-.8 0-1.4-.5-1.4-1.1 0-.6.6-1.2 1.4-1.2.7 0 1.3.6 1.3 1.2s-.6 1.2-1.3 1.2zm0-3.8c-.7 0-1.1-.4-1.1-1 0-.5.4-.9 1-.9.7 0 1.1.4 1.1 1 0 .5-.4 1-1 1zm0 5.4c1.8 0 3-1.3 3-2.7 0-1.4-1.2-2-1.2-2s1-.6 1-1.7c0-1.2-1.2-2.4-2.8-2.4-1.7 0-2.8 1.2-2.8 2.4 0 1.1 1 1.6 1 1.6s-1.3.7-1.3 2c0 1.5 1.3 2.8 3 2.8zm14-2.9h.4L99.8 59h1.9l2.3-3.6s.7-.9.7-2c0-1.7-1.3-3-3.1-3-1.9 0-3.2 1.3-3.2 3a3 3 0 0 0 2.9 2.9zm-1-3c0-.7.5-1.3 1.4-1.3.8 0 1.4.6 1.4 1.4 0 .7-.6 1.3-1.4 1.3-.9 0-1.5-.6-1.5-1.3zm9.5-2.7s-.3 1-1.7 1.1V53h1.4V59h1.8v-8.4h-1.5zm7.3 4.2c0-1.9 1-2.8 1.8-2.8 1 0 1.8 1 1.8 2.8 0 1.9-.9 2.8-1.8 2.8s-1.8-1-1.8-2.8zm5.4 0c0-2.7-1.6-4.4-3.6-4.4-1.9 0-3.6 1.7-3.6 4.4s1.7 4.4 3.6 4.4c2 0 3.6-1.7 3.6-4.4zm5.2-4.2s-.4 1-1.7 1.1V53h1.4V59h1.8v-8.4h-1.5zm16 8.4v-1.7h-3.7c1-1.5 3.6-1.9 3.6-4.2 0-1.5-1.2-2.7-3-2.7-2.3 0-2.9 2-2.9 2l1.5.7s.3-1 1.4-1c.7 0 1.2.4 1.2 1 0 2-4 2-4 5.9h5.8zm7.8-4.4s1.2-.5 1.2-1.8-1.1-2.4-2.8-2.4c-2 0-3 1.3-3 1.3l1.2 1s.6-.7 1.6-.7c.7 0 1.1.4 1.1 1 0 .5-.4 1-1.1 1h-.9v1.5h1c.8 0 1.3.4 1.3 1s-.5 1.1-1.4 1.1c-1.2 0-2-.9-2-.9l-1 1.2s1 1.3 3.2 1.3c1.9 0 3-1.2 3-2.5 0-1.7-1.4-2.1-1.4-2.1zm10.4 1.3v-5.3h-2.1l-3.7 5.1v1.8h4V59h1.8v-1.5h1v-1.6h-1zm-1.8 0h-2.3l2.3-3.2v3.2zm9.3-2.5c-.8 0-1.3.3-1.3.3l.1-1.5h3.5v-1.6h-5.1l-.3 4.8 1.3.1s.4-.6 1.3-.6 1.5.6 1.5 1.3c0 .8-.6 1.4-1.5 1.4-1.2 0-1.9-.9-1.9-.9l-1 1.2s.9 1.3 3 1.3c2 0 3.2-1.3 3.2-3 0-1.6-1.2-2.8-2.8-2.8zM16.8 92.7V99h2.3a3.2 3.2 0 1 0 0-6.3h-2.3zm2.3 1.2c1.1 0 2 .9 2 2 0 1-1 1.9-2 1.9h-1v-3.9h1zm6.3 3.9v-1.4H28v-1.2h-2.6v-1.3h3.3v-1.2h-4.6V99h4.7v-1.2h-3.4zm9.4 1.2v-1.2h-3v-5.1h-1.3V99h4.3zm1.5 0h1.3v-6.3h-1.3V99zm6.7-3.4v1h1.2v.8s-.5.5-1.4.5a2 2 0 0 1-2.1-2c0-1.2.9-2.1 2-2.1 1.2 0 1.8.9 1.8.9l.9-.9s-.9-1.2-2.6-1.2c-2 0-3.4 1.5-3.4 3.3 0 1.8 1.4 3.2 3.4 3.2 1.8 0 2.7-1.2 2.7-1.2v-2.3H43zm9.8-2.9h-1.3v2.5h-2.7v-2.5h-1.4V99h1.4v-2.6h2.7V99h1.3v-6.3zm1.5 0v1.2H56V99h1.3v-5h1.8v-1.3h-5zm13.4 3.1c0-1.3.7-2 1.4-2s1.3.7 1.3 2c0 1.4-.6 2.1-1.3 2.1-.7 0-1.4-.7-1.4-2zm4.1 0c0-2-1.3-3.2-2.7-3.2-1.4 0-2.7 1.2-2.7 3.3 0 2 1.3 3.2 2.7 3.2 1.4 0 2.7-1.2 2.7-3.3zm4.1 0c0-1.3.7-2 1.4-2s1.3.7 1.3 2c0 1.4-.6 2.1-1.3 2.1-.7 0-1.4-.7-1.4-2zm4 0c0-2-1.2-3.2-2.6-3.2-1.5 0-2.7 1.2-2.7 3.3 0 2 1.2 3.2 2.7 3.2 1.4 0 2.7-1.2 2.7-3.3zm4.2 0c0-1.3.7-2 1.4-2s1.3.7 1.3 2c0 1.4-.6 2.1-1.3 2.1-.7 0-1.4-.7-1.4-2zm4 0c0-2-1.2-3.2-2.6-3.2-1.5 0-2.7 1.2-2.7 3.3 0 2 1.2 3.2 2.7 3.2 1.4 0 2.7-1.2 2.7-3.3zm4.2 0c0-1.3.7-2 1.4-2 .6 0 1.3.7 1.3 2 0 1.4-.7 2.1-1.3 2.1-.7 0-1.4-.7-1.4-2zm4 0c0-2-1.2-3.2-2.6-3.2-1.5 0-2.7 1.2-2.7 3.3 0 2 1.2 3.2 2.7 3.2 1.4 0 2.7-1.2 2.7-3.3zm4.2 0c0-1.3.7-2 1.4-2 .6 0 1.3.7 1.3 2 0 1.4-.7 2.1-1.3 2.1-.7 0-1.4-.7-1.4-2zm4 0c0-2-1.2-3.2-2.6-3.2-1.5 0-2.7 1.2-2.7 3.3 0 2 1.2 3.2 2.7 3.2 1.4 0 2.7-1.2 2.7-3.3zm4.2 0c0-1.3.7-2 1.3-2 .7 0 1.4.7 1.4 2 0 1.4-.7 2.1-1.4 2.1-.6 0-1.3-.7-1.3-2zm4 0c0-2-1.2-3.2-2.7-3.2-1.4 0-2.7 1.2-2.7 3.3 0 2 1.3 3.2 2.7 3.2 1.5 0 2.7-1.2 2.7-3.3zM83 74h.6l1-2.8H84l-.8 2-.7-2H82l1 2.8zm3.2-1.2h-.7l.3-.9.4 1zm.2.5l.2.7h.6l-1-2.8h-.7L84.4 74h.6l.3-.7h1zm3.1.7v-.5h-1.3v-2.3h-.6V74h2zm.5 0h.6v-2.8H90V74zm1.3-2.8V74h1a1.4 1.4 0 1 0 0-2.8h-1zm1 .5c.5 0 .9.4.9.9s-.4.9-.8.9h-.5v-1.8h.5zm-9.7 3.5v.5h.8V78h.6v-2.3h.8v-.5h-2.2zm5 0h-.5v1.1h-1.2v-1.1h-.6V78h.6v-1.1H87V78h.6v-2.8zm.8 2.8h.6v-1h.5l.6 1h.6l-.6-1s.5-.3.5-.9c0-.5-.4-.9-1-.9h-1.2V78zm1.6-1.9c0 .2-.2.4-.4.4H89v-.8h.6c.2 0 .4.2.4.4zm2.4 1.4c-.3 0-.6-.3-.6-.6v-1.7h-.6v1.7c0 .6.5 1.2 1.2 1.2s1.3-.6 1.3-1.2v-1.7H93v1.7c0 .3-.3.6-.7.6zM99.6 74.2c0-1.2.6-1.8 1.2-1.8s1.2.6 1.2 1.8c0 1.2-.6 1.8-1.2 1.8s-1.2-.6-1.2-1.8zm3.6 0c0-1.8-1-3-2.4-3-1.2 0-2.4 1.2-2.4 3s1.2 3 2.4 3c1.3 0 2.4-1.2 2.4-3zm3 2c-.6 0-1-.5-1-.9s.4-.8 1-.8c.4 0 .8.4.8.8s-.4.8-.9.8zm0-2.6c-.5 0-.8-.3-.8-.7 0-.3.3-.6.7-.6.5 0 .7.3.7.6 0 .4-.2.7-.7.7zm0 3.5c1.1 0 2-.8 2-1.8 0-.9-.9-1.3-.9-1.3s.7-.4.7-1.2c0-.8-.8-1.5-1.9-1.5-1 0-1.8.7-1.8 1.5s.6 1.2.6 1.2-.8.4-.8 1.3c0 1 .8 1.8 2 1.8zm6-5.8h-1l-2.4 7.4h1l2.4-7.4zm4.4 5.7v-1.1h-2.4c.7-1 2.4-1.3 2.4-2.8 0-1-.8-1.8-2-1.8-1.5 0-1.9 1.3-1.9 1.3l1 .5s.2-.7 1-.7c.4 0 .7.3.7.7 0 1.3-2.7 1.3-2.7 3.9h4zm2.1-2.8c0-1.2.6-1.8 1.2-1.8s1.2.6 1.2 1.8c0 1.2-.6 1.8-1.2 1.8s-1.2-.6-1.2-1.8zm3.6 0c0-1.8-1-3-2.4-3-1.3 0-2.4 1.2-2.4 3s1.1 3 2.4 3c1.3 0 2.4-1.2 2.4-3z"
      fill="#FFFFEB"
    />
    <path
      d="M159.7 94.8c.6 6.2-4.4 9.9-9.8 9.9-6.2 0-9.2-5-9.8-9.9-.7-5.3 4.4-10.3 9.8-9.8 6.7.6 9.2 4.5 9.8 9.8z"
      fill="#C53E35"
    />
    <path
      d="M172 94.8c.6 6.2-4.4 9.9-9.8 9.9-6.1 0-9.2-5-9.8-9.9-.7-5.3 4.4-10.3 9.8-9.8 6.7.6 9.3 4.5 9.8 9.8z"
      fill="#FCF6C6"
    />
    {withText && (
      <React.Fragment>
        <g filter="url(#filter0_d)" stroke="#191919">
          <rect x="133.5" y="42.5" width="43" height="24" rx="3.5" />
          <path d="M176 53.5h40" />
        </g>
        <Text x="224" y="58">
          {lastfour}
        </Text>
        <Text x="224" y="100">
          {delightnumber}
        </Text>
        <g filter="url(#filter1_d)" stroke="#191919">
          <rect x="62.5" y="86.5" width="53" height="19" rx="3.5" />
          <path d="M116 96.5h100" />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="125"
            y="36"
            width="99"
            height="41"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d"
            x="54"
            y="80"
            width="170"
            height="36"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </React.Fragment>
    )}
  </Svg>
)

RedCard.defaultProps = {
  height: 119,
  withText: false,
  lastfour: 'Last four digits',
  delightnumber: 'Delight number',
}

export default RedCard
